var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-input",class:{ 'border': _vm.showBorder }},[_c('van-field',_vm._g(_vm._b({},'van-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }